<template>
  <div class="riskPage">
    <!-- 页头 -->
    <div class="riskHead">
      <h2>{{ pageTitle }}<em :style="{ background: themeColor }">风控模块</em></h2>
      <p class="riskSub">按分公司 / 合伙人 / 业绩归属人 / 项目 / 月份范围筛选，图表与明细同步联动</p>
    </div>

    <!-- 筛选栏 -->
    <div class="riskCard filterBar">
      <div class="filterRow">
        <span class="fl">分公司</span>
        <el-select v-model="filter.Branch" size="small" clearable filterable placeholder="全部" style="width:150px">
          <el-option v-for="(o,i) in options.branchOptions" :key="i" :value="o.value" :label="o.label"></el-option>
        </el-select>
        <span class="fl">合伙人</span>
        <el-select v-model="filter.Partner" size="small" clearable filterable placeholder="全部" style="width:140px">
          <el-option v-for="(o,i) in options.partnerOptions" :key="i" :value="o.value" :label="o.label"></el-option>
        </el-select>
        <span class="fl">业绩归属人</span>
        <el-select v-model="filter.AchieveOwner" size="small" clearable filterable placeholder="全部" style="width:140px">
          <el-option v-for="(o,i) in options.achieveOwnerOptions" :key="i" :value="o.value" :label="o.label"></el-option>
        </el-select>
        <span class="fl">项目</span>
        <el-select v-model="filter.ProjectName" size="small" clearable filterable placeholder="全部" style="width:180px">
          <el-option v-for="(o,i) in options.projectOptions" :key="i" :value="o.value" :label="o.label"></el-option>
        </el-select>
      </div>
      <div class="filterRow" style="margin-top:10px">
        <span class="fl">归属月</span>
        <el-date-picker v-model="filter.AttrMonthBegin" type="month" size="small" value-format="yyyyMM" placeholder="起" style="width:130px"></el-date-picker>
        <span style="margin:0 6px;color:#6B7392">至</span>
        <el-date-picker v-model="filter.AttrMonthEnd" type="month" size="small" value-format="yyyyMM" placeholder="止" style="width:130px"></el-date-picker>
        <span class="fl">等级</span>
        <el-select v-model="filter.Level" size="small" clearable placeholder="全部" style="width:110px">
          <el-option :value="4" label="红"></el-option>
          <el-option :value="3" label="橙"></el-option>
          <el-option :value="2" label="黄"></el-option>
          <el-option :value="1" label="蓝"></el-option>
        </el-select>
        <span class="fl">状态</span>
        <el-select v-model="filter.Status" size="small" clearable placeholder="全部" style="width:110px">
          <el-option value="pending" label="待处理"></el-option>
          <el-option value="following" label="跟进中"></el-option>
          <el-option value="writeoff" label="已核销"></el-option>
        </el-select>
        <el-button size="small" type="primary" style="margin-left:12px" @click="onSearch">查询</el-button>
        <el-button size="small" @click="onReset">重置</el-button>
        <div style="margin-left:auto;display:flex;align-items:center">
          <el-badge :value="todoBadge" :hidden="todoBadge === 0" :max="99">
            <el-button size="small" icon="el-icon-bell" @click="openTodo">消息中心</el-button>
          </el-badge>
        </div>
      </div>
      <!-- 风险子类 TAB -->
      <div v-if="subTabs && subTabs.length" class="filterRow" style="margin-top:10px">
        <el-radio-group v-model="filter.SubType" size="small" @change="onSearch">
          <el-radio-button v-for="(t,i) in subTabs" :key="i" :label="t">{{ t }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>

    <!-- 关键指标卡 -->
    <div class="metricRow">
      <div class="metricCard s-red">
        <div class="mv">{{ metrics.activeCount }}<small> 条</small></div>
        <div class="ml">活跃预警数</div>
      </div>
      <div class="metricCard s-orange">
        <div class="mv">{{ metrics.monthNewCount }}<small> 条</small></div>
        <div class="ml">本月新增</div>
      </div>
      <div class="metricCard s-amber">
        <div class="mv" style="color:#FF9F1C">{{ metrics.over3MonthCount }}<small> 条</small></div>
        <div class="ml">超过 3 个月未核销</div>
      </div>
      <div class="metricCard s-purple">
        <div class="mv" style="color:#FF3B5C">{{ metrics.over6MonthCount }}<small> 条</small></div>
        <div class="ml">超过 6 个月未核销</div>
      </div>
      <div class="metricCard s-green">
        <div class="mv" style="color:#00A576">{{ metrics.writeOffCount }}<small> 条</small></div>
        <div class="ml">已累计核销</div>
      </div>
    </div>

    <!-- 趋势图 + TOP10 -->
    <div class="chartRow">
      <div class="riskCard chartCard">
        <div class="flex aic" style="justify-content:space-between">
          <h3>账龄 / 预警趋势</h3>
          <el-radio-group v-model="trendMonths" size="mini" @change="loadTrend">
            <el-radio-button :label="12">近 12 月</el-radio-button>
            <el-radio-button :label="24">近 24 月</el-radio-button>
          </el-radio-group>
        </div>
        <div ref="trendChart" style="height:280px;width:100%"></div>
      </div>
      <div class="riskCard chartCard">
        <div class="flex aic" style="justify-content:space-between">
          <h3>TOP10 排名 <small style="font-weight:400;font-size:12px;color:#8A93AE">按预警条数排序，点击柱子可按该维度下钻</small></h3>
          <el-radio-group v-model="topDim" size="mini" @change="loadTop">
            <el-radio-button label="branch">分公司</el-radio-button>
            <el-radio-button label="partner">合伙人</el-radio-button>
            <el-radio-button label="achieveOwner">业绩归属人</el-radio-button>
            <el-radio-button label="project">项目</el-radio-button>
          </el-radio-group>
        </div>
        <div ref="topChart" style="height:300px;width:100%"></div>
      </div>
    </div>

    <!-- 预警明细 -->
    <div class="riskCard">
      <div class="flex aic" style="justify-content:space-between;margin-bottom:10px">
        <h3>预警明细</h3>
        <el-input v-model="filter.Keyword" size="small" placeholder="预警编号 / 项目名" style="width:220px" @keyup.enter.native="onSearch"></el-input>
      </div>
      <el-table :data="rows" border size="small" :row-class-name="rowClass" style="width:100%">
        <el-table-column prop="alertNo" label="预警编号" width="130" align="center"></el-table-column>
        <el-table-column prop="projectName" label="项目 / 部门" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column label="分公司" width="130" show-overflow-tooltip>
          <template slot-scope="s">{{ s.row.branchName || s.row.branch || '-' }}</template>
        </el-table-column>
        <el-table-column label="合伙人" width="110" show-overflow-tooltip>
          <template slot-scope="s">{{ s.row.partnerName || s.row.partner || '-' }}</template>
        </el-table-column>
        <el-table-column label="业绩归属人" width="120" show-overflow-tooltip>
          <template slot-scope="s">{{ s.row.achieveOwnerName || s.row.achieveOwner || '-' }}</template>
        </el-table-column>
        <el-table-column prop="subType" label="风险子类" width="130"></el-table-column>
        <el-table-column prop="attrMonth" label="归属月" width="90" align="center"></el-table-column>
        <el-table-column prop="personCount" label="涉及人数" width="90" align="center"></el-table-column>
        <el-table-column v-if="showAmount" prop="amount" label="金额(元)" width="120" align="right">
          <template slot-scope="s">{{ fmtMoney(s.row.amount) }}</template>
        </el-table-column>
        <el-table-column label="等级" width="80" align="center">
          <template slot-scope="s">
            <span class="lvTag" :style="lvStyle(s.row.level)">{{ s.row.levelName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="s">{{ s.row.statusName }}</template>
        </el-table-column>
        <el-table-column label="操作" width="300" align="center">
          <template slot-scope="s">
            <el-button type="text" size="mini" @click="openDetail(s.row)">详情</el-button>
            <el-button type="text" size="mini" @click="openItems(s.row)">下钻</el-button>
            <el-button type="text" size="mini" @click="openFollow(s.row)">跟进</el-button>
            <el-button type="text" size="mini" @click="openUrge(s.row)">催办</el-button>
            <el-button type="text" size="mini" @click="openWriteOff(s.row)">核销</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top:12px;text-align:right" :current-page="page.Page" :page-size="page.Rows"
        :total="page.TotalCount" layout="total, sizes, prev, pager, next" :page-sizes="[10,20,50]"
        @current-change="p => { page.Page = p; loadList() }" @size-change="s => { page.Rows = s; loadList() }"></el-pagination>
    </div>

    <!-- 下钻明细 -->
    <el-dialog :title="'明细 · ' + curTitle" :visible.sync="itemVisible" width="70%">
      <el-table :data="itemRows" border size="small" max-height="440">
        <el-table-column prop="empName" label="姓名" width="100"></el-table-column>
        <el-table-column prop="strIdCard" label="身份证" width="170"></el-table-column>
        <el-table-column prop="projectName" label="项目" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="legalEntity" label="公司主体" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="attrMonth" label="归属月" width="90" align="center"></el-table-column>
        <el-table-column prop="amount" label="金额(元)" width="110" align="right">
          <template slot-scope="s">{{ fmtMoney(s.row.amount) }}</template>
        </el-table-column>
        <el-table-column prop="workState" label="在职" width="80" align="center"></el-table-column>
        <el-table-column prop="payState" label="发薪状态" width="100" align="center"></el-table-column>
        <el-table-column label="等级" width="80" align="center">
          <template slot-scope="s"><span class="lvTag" :style="lvStyle(s.row.level)">{{ s.row.levelName }}</span></template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 详情弹窗 -->
    <el-dialog title="预警详情" :visible.sync="detailVisible" width="60%">
      <div v-if="detail.alert">
        <el-descriptions :column="2" border size="small">
          <el-descriptions-item label="预警编号">{{ detail.alert.alertNo }}</el-descriptions-item>
          <el-descriptions-item label="风险域">{{ detail.alert.domainName }}</el-descriptions-item>
          <el-descriptions-item label="项目">{{ detail.alert.projectName }}</el-descriptions-item>
          <el-descriptions-item label="公司主体">{{ detail.alert.legalEntity }}</el-descriptions-item>
          <el-descriptions-item label="归属月">{{ detail.alert.attrMonth }}</el-descriptions-item>
          <el-descriptions-item label="等级">
            <span class="lvTag" :style="lvStyle(detail.alert.level)">{{ detail.alert.levelName }}</span>
          </el-descriptions-item>
          <el-descriptions-item label="状态">{{ detail.alert.statusName }}</el-descriptions-item>
          <el-descriptions-item label="原因" :span="2">{{ detail.alert.reason }}</el-descriptions-item>
        </el-descriptions>
        <h4 style="margin:14px 0 6px">跟进记录</h4>
        <el-table :data="detail.follows" border size="small" max-height="200">
          <el-table-column prop="createTime" label="时间" width="150"></el-table-column>
          <el-table-column prop="userName" label="跟进人" width="100"></el-table-column>
          <el-table-column prop="content" label="内容" min-width="200"></el-table-column>
        </el-table>
        <h4 style="margin:14px 0 6px">催办记录</h4>
        <el-table :data="detail.urges" border size="small" max-height="200">
          <el-table-column prop="createTime" label="时间" width="150"></el-table-column>
          <el-table-column prop="fromUserName" label="发起人" width="100"></el-table-column>
          <el-table-column prop="content" label="内容" min-width="200"></el-table-column>
        </el-table>
        <h4 style="margin:14px 0 6px">核销申请</h4>
        <el-table :data="detail.writeoffs || []" border size="small" max-height="200">
          <el-table-column prop="applyUserName" label="申请人" width="90"></el-table-column>
          <el-table-column prop="reason" label="核销理由" min-width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="approverName" label="审批人" width="90"></el-table-column>
          <el-table-column label="状态" width="90" align="center">
            <template slot-scope="s">
              <span :style="{ color: s.row.status === 'pass' ? '#00A576' : (s.row.status === 'reject' ? '#FF3B5C' : '#FF9F1C') }">{{ s.row.statusName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="approveRemark" label="审批意见" min-width="130" show-overflow-tooltip></el-table-column>
          <el-table-column label="申请时间" width="95" align="center">
            <template slot-scope="s">{{ (s.row.createTime || '').replace('T', ' ').slice(0, 16) }}</template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 跟进 / 催办 / 核销 -->
    <el-dialog title="跟进" :visible.sync="followVisible" width="30%">
      <el-input type="textarea" :rows="4" v-model="followForm.Content" placeholder="请填写跟进说明"></el-input>
      <div slot="footer">
        <el-button size="small" @click="followVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitFollow">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog title="催办" :visible.sync="urgeVisible" width="30%">
      <el-select v-model="urgeForm.ToUserId" size="small" filterable allow-create default-first-option
        placeholder="选择催办对象" style="width:100%;margin-bottom:10px">
        <el-option :value="approver.id" :label="approver.name + '（风控审批人）'"></el-option>
      </el-select>
      <el-input type="textarea" :rows="3" v-model="urgeForm.Content" placeholder="催办内容"></el-input>
      <div slot="footer">
        <el-button size="small" @click="urgeVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitUrge">发送</el-button>
      </div>
    </el-dialog>
    <el-dialog title="人工核销" :visible.sync="woVisible" width="30%">
      <div style="margin-bottom:10px;font-size:13px;color:#6B7392">审批人：<b style="color:#141A33">{{ approver.name }}</b>（风控审批人）</div>
      <el-input type="textarea" :rows="4" v-model="woForm.Reason" placeholder="请填写核销理由"></el-input>
      <div slot="footer">
        <el-button size="small" @click="woVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitWriteOff">提交审批</el-button>
      </div>
    </el-dialog>

    <!-- 消息中心：收到的催办 / 审批提醒 + 待审批核销单 -->
    <el-drawer title="消息中心" :visible.sync="todoVisible" size="52%">
      <div style="padding:0 18px 24px">
        <el-tabs v-model="todoTab">
          <el-tab-pane :label="`我的消息 (${(myTodo.messages || []).length})`" name="msg">
            <div style="margin-bottom:8px;text-align:right">
              <el-button size="mini" :disabled="todoBadge === 0" @click="readAllUrge">全部已读</el-button>
            </div>
            <el-table :data="myTodo.messages" border size="small" max-height="560">
              <el-table-column label="类型" width="92" align="center">
                <template slot-scope="s">
                  <span class="todoTag" :style="todoTypeStyle(s.row.type)">{{ todoTypeName(s.row.type) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="内容" min-width="260">
                <template slot-scope="s">
                  <span :style="{ fontWeight: s.row.isRead ? 400 : 700 }">{{ s.row.content }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="fromUserName" label="发起人" width="90"></el-table-column>
              <el-table-column label="时间" width="95" align="center">
                <template slot-scope="s">{{ (s.row.createTime || '').replace('T', ' ').slice(0, 16) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="130" align="center">
                <template slot-scope="s">
                  <el-button v-if="!s.row.isRead" type="text" size="mini" @click="readUrge(s.row)">标为已读</el-button>
                  <el-button type="text" size="mini" @click="jumpTodo(s.row)">查看预警</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane :label="`待审批核销 (${(myTodo.audits || []).length})`" name="audit">
            <el-table :data="myTodo.audits" border size="small" max-height="590">
              <el-table-column prop="alertNo" label="预警编号" width="130"></el-table-column>
              <el-table-column prop="projectName" label="项目" min-width="130" show-overflow-tooltip></el-table-column>
              <el-table-column prop="subType" label="风险子类" width="120"></el-table-column>
              <el-table-column label="等级" width="70" align="center">
                <template slot-scope="s"><span class="lvTag" :style="lvStyle(s.row.level)">{{ s.row.levelName }}</span></template>
              </el-table-column>
              <el-table-column prop="reason" label="核销理由" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column prop="applyUserName" label="申请人" width="90"></el-table-column>
              <el-table-column label="申请时间" width="95" align="center">
                <template slot-scope="s">{{ (s.row.createTime || '').replace('T', ' ').slice(0, 16) }}</template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="s">
                  <el-button type="text" size="mini" style="color:#00A576" @click="auditWriteOff(s.row, true)">通过</el-button>
                  <el-button type="text" size="mini" style="color:#FF3B5C" @click="auditWriteOff(s.row, false)">驳回</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import xz from "@/common";
import * as echarts from "echarts";

const LV_COLOR = { 4: '#FF3B5C', 3: '#FF9F1C', 2: '#FFC531', 1: '#2E7BFF' };

//人工核销审批人（原型阶段写死：张鹏），与后端 EarlyWarnService.WRITEOFF_APPROVER_* 保持一致
const APPROVER = { id: 'c895257-5e33-4888-9bd8-adb6df000072', name: '张鹏' };

export default {
  name: 'riskWarn',
  props: {
    domain: { type: String, required: true },       // labor / ar / payroll / social
    pageTitle: { type: String, default: '风险预警' },
    themeColor: { type: String, default: '#7C5CFF' },
    subTabs: { type: Array, default: () => [] },
    showAmount: { type: Boolean, default: true }
  },
  data() {
    return {
      filter: { Branch: '', Partner: '', AchieveOwner: '', ProjectName: '', AttrMonthBegin: '', AttrMonthEnd: '', Level: null, Status: '', SubType: '', Keyword: '' },
      options: { branchOptions: [], partnerOptions: [], achieveOwnerOptions: [], projectOptions: [] },
      metrics: { activeCount: 0, monthNewCount: 0, over3MonthCount: 0, over6MonthCount: 0, writeOffCount: 0 },
      rows: [], page: { Page: 1, Rows: 10, TotalCount: 0 },
      trendMonths: 12, topDim: 'branch', topRows: [],
      trendChart: null, topChart: null,
      itemVisible: false, itemRows: [], curTitle: '',
      detailVisible: false, detail: {},
      followVisible: false, followForm: { AlertId: '', Content: '' },
      urgeVisible: false, urgeForm: { AlertId: '', ToUserId: '', Content: '' },
      woVisible: false, woForm: { AlertId: '', Reason: '', ApproverId: APPROVER.id },
      approver: APPROVER,
      todoVisible: false, todoTab: 'msg',
      myTodo: { unreadUrges: 0, pendingAudits: 0, messages: [], audits: [] }
    }
  },
  computed: {
    //消息中心角标：未读消息 + 待审批核销单
    todoBadge() { return (this.myTodo.unreadUrges || 0) + (this.myTodo.pendingAudits || 0) }
  },
  mounted() {
    this.loadOptions();
    this.loadMetrics();
    this.loadMyTodo();
    this.loadTrend();
    this.loadTop();
    this.loadList();
    window.addEventListener('resize', this.resizeCharts)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCharts)
    if (this.trendChart) this.trendChart.dispose()
    if (this.topChart) this.topChart.dispose()
  },
  methods: {
    buildParam() {
      return Object.assign({
        Domain: this.domain,
        PageModel: { Page: this.page.Page, Rows: this.page.Rows },
        MonthCount: this.trendMonths, Dim: this.topDim, TopCount: 10
      }, this.filter)
    },
    //后端返回体字段名可能为大驼峰或小驼峰，这里统一兼容取值，避免某处配置变化后整页取不到值
    pick(o, key, def) {
      if (!o) return def
      if (o[key] !== undefined && o[key] !== null) return o[key]
      const up = key.charAt(0).toUpperCase() + key.slice(1)
      if (o[up] !== undefined && o[up] !== null) return o[up]
      return def
    },
    async loadOptions() {
      const r = await xz.EarlyWarnGet('GetRiskFilterOptions', { domain: this.domain })
      if (!r || r.status !== 'ok' || !r.data) return
      const d = r.data
      //分公司/合伙人/业绩归属人存的是编码与人员Id：value 回传库里存的值，label 展示名称
      this.options = {
        branchOptions: this.pick(d, 'branchOptions', []) || [],
        partnerOptions: this.pick(d, 'partnerOptions', []) || [],
        achieveOwnerOptions: this.pick(d, 'achieveOwnerOptions', []) || [],
        projectOptions: this.pick(d, 'projectOptions', []) || []
      }
    },
    async loadMetrics() {
      const r = await xz.EarlyWarn(this.buildParam(), 'GetRiskMetrics')
      if (!r || r.status !== 'ok' || !r.data) return
      const d = r.data
      this.metrics = {
        activeCount: this.pick(d, 'activeCount', 0),
        monthNewCount: this.pick(d, 'monthNewCount', 0),
        over3MonthCount: this.pick(d, 'over3MonthCount', 0),
        over6MonthCount: this.pick(d, 'over6MonthCount', 0),
        writeOffCount: this.pick(d, 'writeOffCount', 0)
      }
    },
    async loadList() {
      const r = await xz.EarlyWarn(this.buildParam(), 'GetRiskAlertPageList')
      if (r && r.status === 'ok' && r.data) {
        const d = r.data
        const pm = this.pick(d, 'pageModel', {}) || {}
        this.rows = this.pick(d, 'data', []) || []
        this.page = {
          Page: this.pick(pm, 'page', 1),
          Rows: this.pick(pm, 'rows', 10),
          TotalCount: this.pick(pm, 'totalCount', 0)
        }
      } else {
        this.rows = []
      }
    },
    async loadTrend() {
      const r = await xz.EarlyWarn(Object.assign({}, this.buildParam(), { monthCount: this.trendMonths }), 'GetRiskTrend')
      if (!r || r.status !== 'ok' || !r.data) return
      const d = r.data
      const series = this.pick(d, 'series', {}) || {}
      this.trendChart = this.trendChart || echarts.init(this.$refs.trendChart)
      this.trendChart.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: ['红', '橙', '黄', '蓝'] },
        grid: { left: 40, right: 20, top: 40, bottom: 30 },
        xAxis: { type: 'category', data: this.pick(d, 'months', []) || [] },
        yAxis: { type: 'value' },
        series: [
          { name: '红', type: 'line', smooth: true, itemStyle: { color: '#FF3B5C' }, areaStyle: { opacity: 0.12 }, data: series.red || [] },
          { name: '橙', type: 'line', smooth: true, itemStyle: { color: '#FF9F1C' }, areaStyle: { opacity: 0.12 }, data: series.orange || [] },
          { name: '黄', type: 'line', smooth: true, itemStyle: { color: '#FFC531' }, areaStyle: { opacity: 0.12 }, data: series.yellow || [] },
          { name: '蓝', type: 'line', smooth: true, itemStyle: { color: '#2E7BFF' }, areaStyle: { opacity: 0.12 }, data: series.blue || [] }
        ]
      }, true)
    },
    async loadTop() {
      const r = await xz.EarlyWarn(Object.assign({}, this.buildParam(), { dim: this.topDim, topCount: 10 }), 'GetRiskTopRank')
      if (!r || r.status !== 'ok' || !r.data) return
      const list = r.data || []
      this.topRows = list

      //横向堆叠：按红/橙/黄/蓝拆解，柱子长度=预警条数，便于看出「谁家问题最多、严重程度如何」
      const asc = list.slice().reverse()
      const names = asc.map(x => this.pick(x, 'name', '') || '未分配')
      const red = asc.map(x => this.pick(x, 'redCount', 0))
      const orange = asc.map(x => this.pick(x, 'orangeCount', 0))
      const yellow = asc.map(x => this.pick(x, 'yellowCount', 0))
      const blue = asc.map(x => this.pick(x, 'blueCount', 0))
      const total = asc.map(x => this.pick(x, 'count', 0))
      const chart = this.topChart = this.topChart || echarts.init(this.$refs.topChart)

      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          formatter: (ps) => {
            const i = ps[0].dataIndex
            const row = asc[i] || {}
            const lines = [`<b>${names[i]}</b>`,
              `预警 ${total[i]} 条（占比 ${this.pick(row, 'rate', 0)}%）`]
            if (this.showAmount) lines.push(`金额 ${this.fmtMoney(this.pick(row, 'value', 0))} 元`)
            const lv = [['红', red[i], '#FF3B5C'], ['橙', orange[i], '#FF9F1C'], ['黄', yellow[i], '#FFC531'], ['蓝', blue[i], '#2E7BFF']]
            lv.forEach(([t, v, c]) => { if (v > 0) lines.push(`<span style="color:${c}">■</span> ${t} ${v} 条`) })
            return lines.join('<br/>')
          }
        },
        legend: { data: ['红', '橙', '黄', '蓝'], top: 0, itemWidth: 9, itemHeight: 9, textStyle: { fontSize: 11 } },
        grid: { left: 8, right: 44, top: 30, bottom: 6, containLabel: true },
        xAxis: { type: 'value', axisLabel: { fontSize: 11, color: '#8A93AE' }, splitLine: { lineStyle: { color: '#EEF1F9' } } },
        yAxis: {
          type: 'category', data: names, axisTick: { show: false }, axisLine: { show: false },
          axisLabel: { fontSize: 11.5, color: '#4A5470', width: 120, overflow: 'truncate' }
        },
        series: [
          { name: '红', type: 'bar', stack: 'lv', barWidth: 13, itemStyle: { color: '#FF3B5C', borderRadius: [3, 0, 0, 3] }, data: red },
          { name: '橙', type: 'bar', stack: 'lv', barWidth: 13, itemStyle: { color: '#FF9F1C' }, data: orange },
          { name: '黄', type: 'bar', stack: 'lv', barWidth: 13, itemStyle: { color: '#FFC531' }, data: yellow },
          {
            name: '蓝', type: 'bar', stack: 'lv', barWidth: 13,
            itemStyle: { color: '#2E7BFF', borderRadius: [0, 3, 3, 0] }, data: blue,
            label: {
              show: true, position: 'right', fontSize: 11, color: '#4A5470',
              formatter: (p) => total[p.dataIndex] || ''
            }
          }
        ]
      }, true)

      chart.off('click')
      chart.on('click', (p) => this.drillTop(p.name))
    },
    //点击榜单某一条 → 把该维度值回填到筛选栏并刷新（分公司/合伙人/业绩归属人存的是编码与Id）
    drillTop(name) {
      const row = (this.topRows || []).find(x => (this.pick(x, 'name', '') || '未分配') === name)
      if (!row) return
      const code = this.pick(row, 'code', '')
      if (!code || code === '未分配') {
        this.$message.warning('该分组没有可下钻的维度值')
        return
      }
      if (this.topDim === 'branch') this.filter.Branch = code
      else if (this.topDim === 'partner') this.filter.Partner = code
      else if (this.topDim === 'achieveOwner') this.filter.AchieveOwner = code
      else this.filter.ProjectName = code

      this.page.Page = 1
      this.loadMetrics(); this.loadTrend(); this.loadList()
      this.$message.success(`已按「${name}」下钻筛选`)
    },
    async openItems(row) {
      this.curTitle = row.alertNo || ''
      const r = await xz.EarlyWarnGet('GetRiskAlertItemList', { alertId: row.id })
      if (r && r.status === 'ok') this.itemRows = r.data || []
      this.itemVisible = true
    },
    async openDetail(row) {
      const r = await xz.EarlyWarnGet('GetRiskAlertDetail', { alertId: row.id })
      if (r && r.status === 'ok') {
        const d = r.data || {}
        this.detail = {
          alert: this.pick(d, 'alert', {}) || {},
          follows: this.pick(d, 'follows', []) || [],
          urges: this.pick(d, 'urges', []) || [],
          writeoffs: this.pick(d, 'writeOffs', []) || []
        }
      }
      this.detailVisible = true
    },
    openFollow(row) { this.followForm = { AlertId: row.id, Content: '' }; this.followVisible = true },
    openUrge(row) { this.urgeForm = { AlertId: row.id, ToUserId: this.approver.id, Content: '' }; this.urgeVisible = true },
    openWriteOff(row) { this.woForm = { AlertId: row.id, Reason: '', ApproverId: this.approver.id }; this.woVisible = true },
    async submitFollow() {
      const r = await xz.EarlyWarn(this.followForm, 'AddRiskFollow')
      this.$message(r && r.status === 'ok' ? '跟进已保存' : (r && r.msg) || '提交失败')
      if (r && r.status === 'ok') { this.followVisible = false; this.loadList(); this.loadMetrics() }
    },
    async submitUrge() {
      const r = await xz.EarlyWarn(this.urgeForm, 'AddRiskUrge')
      this.$message(r && r.status === 'ok' ? '催办已发送' : (r && r.msg) || '提交失败')
      if (r && r.status === 'ok') { this.urgeVisible = false; this.loadMyTodo() }
    },
    async submitWriteOff() {
      const r = await xz.EarlyWarn(this.woForm, 'ApplyRiskWriteOff')
      this.$message(r && r.status === 'ok' ? '核销申请已提交，等待审批' : (r && r.msg) || '提交失败')
      if (r && r.status === 'ok') { this.woVisible = false; this.loadList(); this.loadMyTodo() }
    },

    // ---- 消息中心 ----
    async loadMyTodo() {
      const r = await xz.EarlyWarnGet('GetRiskMyTodo')
      if (!r || r.status !== 'ok' || !r.data) return
      const d = r.data
      this.myTodo = {
        unreadUrges: this.pick(d, 'unreadUrges', 0) || 0,
        pendingAudits: this.pick(d, 'pendingAudits', 0) || 0,
        messages: this.pick(d, 'messages', []) || [],
        audits: this.pick(d, 'audits', []) || []
      }
    },
    openTodo() { this.todoVisible = true; this.loadMyTodo() },
    async readUrge(row) {
      const r = await xz.EarlyWarnGet('ReadRiskUrge', { urgeUserId: row.urgeUserId })
      if (r && r.status === 'ok') this.loadMyTodo()
    },
    async readAllUrge() {
      const r = await xz.EarlyWarnGet('ReadRiskUrge', { urgeUserId: 'all' })
      if (r && r.status === 'ok') this.loadMyTodo()
    },
    auditWriteOff(row, pass) {
      if (pass) { this.doAudit(row, true, ''); return }
      this.$prompt('请填写驳回意见', '驳回核销申请', {
        inputType: 'textarea',
        inputValidator: v => (v && v.trim() ? true : '请填写驳回意见')
      }).then(({ value }) => this.doAudit(row, false, value.trim())).catch(() => {})
    },
    async doAudit(row, pass, remark) {
      const r = await xz.EarlyWarnGet('AuditRiskWriteOff', { writeOffId: row.writeOffId, pass: pass, remark: remark })
      this.$message(r && r.status === 'ok' ? ((r.msg || '') + '') : (r && r.msg) || '操作失败')
      if (r && r.status === 'ok') { this.loadMyTodo(); this.loadList(); this.loadMetrics() }
    },
    jumpTodo(row) {
      this.todoVisible = false
      const map = { labor: '/laborCompliance', ar: '/arUncleared', payroll: '/payrollWarn', social: '/socialRateWarn' }
      this.$router.push(map[row.domain] || '/laborCompliance')
    },
    todoTypeName(t) { return t === 'approve' ? '核销审批' : (t === 'result' ? '审批结果' : '催办') },
    todoTypeStyle(t) {
      const c = t === 'approve' ? '#7C5CFF' : (t === 'result' ? '#00A576' : '#2E7BFF')
      return { background: c + '1A', color: c, border: '1px solid ' + c }
    },
    onSearch() { this.page.Page = 1; this.loadMetrics(); this.loadTrend(); this.loadTop(); this.loadList() },
    onReset() {
      this.filter = { Branch: '', Partner: '', AchieveOwner: '', ProjectName: '', AttrMonthBegin: '', AttrMonthEnd: '', Level: null, Status: '', SubType: '', Keyword: '' }
      this.onSearch()
    },
    resizeCharts() { if (this.trendChart) this.trendChart.resize(); if (this.topChart) this.topChart.resize() },
    lvStyle(lv) { return { background: (LV_COLOR[lv] || '#2E7BFF') + '1A', color: LV_COLOR[lv] || '#2E7BFF', borderColor: LV_COLOR[lv] || '#2E7BFF' } },
    rowClass({ row }) { return row.level === 4 ? 'lvRowRed' : (row.level === 3 ? 'lvRowOrange' : '') },
    fmtMoney(v) { return v === null || v === undefined ? '-' : Number(v).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  }
}
</script>

<style scoped>
.riskPage { padding: 20px 24px 60px; background: #F3F5FC; min-height: 100%; }
.riskHead h2 { font-size: 26px; font-weight: 800; color: #141A33; margin: 0 0 4px; display: flex; align-items: center; }
.riskHead h2 em { font-size: 12px; font-style: normal; color: #fff; border-radius: 6px; padding: 3px 8px; margin-left: 10px; }
.riskSub { font-size: 12.5px; color: #6B7392; margin: 0 0 14px; }
.riskCard { background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 16px 18px; margin-bottom: 14px; }
.riskCard h3 { font-size: 16px; font-weight: 800; color: #141A33; margin: 0 0 10px; }
.filterBar .filterRow { display: flex; align-items: center; flex-wrap: wrap; }
.fl { font-size: 13px; color: #6B7392; margin: 0 6px 0 14px; }
.fl:first-child { margin-left: 0; }
.metricRow { display: grid; grid-template-columns: repeat(5, 1fr); gap: 14px; margin-bottom: 14px; }
.metricCard { background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 14px 16px; border-left: 4px solid #FF3B5C; }
.metricCard.s-orange { border-left-color: #FF9F1C; }
.metricCard.s-amber { border-left-color: #FFC531; }
.todoTag { display: inline-block; font-size: 11px; padding: 2px 8px; border-radius: 10px; }
.metricCard.s-purple { border-left-color: #7C5CFF; }
.metricCard.s-green { border-left-color: #00C48C; }
.mv { font-size: 34px; font-weight: 900; color: #FF3B5C; letter-spacing: -1px; line-height: 1.1; }
.mv small { font-size: 13px; font-weight: 700; }
.ml { font-size: 12px; color: #6B7392; margin-top: 4px; }
.chartRow { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; }
.chartCard { margin-bottom: 14px; }
.lvTag { display: inline-block; min-width: 34px; padding: 1px 8px; border-radius: 10px; border: 1px solid; font-size: 12px; font-weight: 700; }
.flex { display: flex; }
.aic { align-items: center; }
::v-deep .el-table th { background: linear-gradient(90deg, #F2F6FF, #F8F3FF); color: #4A5578; font-size: 13px; font-weight: 800; }
::v-deep .el-table .lvRowRed { background: #FFF5F7; }
::v-deep .el-table .lvRowOrange { background: #FFFBF2; }
</style>
